module.exports = __webpack_public_path__ + "img/vivense_logo_white.ffc63f0b.svg";